import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface OTCSSDParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface OTCSSD { 

    id?:number;
    name?:string;
    branchId: string;
    tenantId: string;  
   
    parameters?: OTCSSDParameter[];
    links?: any;
}


export abstract class OTCSSDData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<OTCSSD[]>;
    abstract create(url: string, data: OTCSSD): Observable<OTCSSD[]>;
    abstract update(url: string, data: OTCSSD): Observable<OTCSSD>;
}
